import Accordion from 'accordion-js';

const header = document.getElementById("header"),
	page = document.querySelectorAll("#page, main")[0],
	$html = document.querySelector("html");

page.style.paddingTop = header.offsetHeight + "px";

window.onresize = function (){
	page.style.paddingTop = header.offsetHeight + "px";
}

function isPageTop(){
	if (scrollY <= 10) {
		$html.classList.add('_page-top');
	} else {
		$html.classList.remove('_page-top');
	}
}
isPageTop();
document.addEventListener('scroll', () => {
	isPageTop();
});

const $burgerBtnMenu = document.querySelector('a[href="#menu"]'),
	$burgerBtnCatalog = document.querySelector('a[href="#menu-catalog"]'),
	catalogWrapper = document.querySelector('.js--burger-menu-catalog'),
	menuWrapper = document.querySelector('.js--burger-menu-general'),
	burgerClose = document.querySelector('.js--burger-menu-close')


burgerClose.addEventListener('click', function (){
	$html.classList.remove('_burger-open');
	catalogWrapper.classList.remove('_active');
	menuWrapper.classList.remove('_active');
})

$burgerBtnMenu.addEventListener('click', (e) => {

	if(catalogWrapper.classList.contains("_active")){
		menuWrapper.classList.toggle('_active');
		catalogWrapper.classList.toggle('_active');
		return;
	}

	if ($html.classList.contains('_burger-open')) {
		$html.classList.remove('_burger-open');
		catalogWrapper.classList.remove('_active');
		menuWrapper.classList.remove('_active');
	} else {
		$html.classList.add('_burger-open');
		menuWrapper.classList.add('_active');
	}

});

$burgerBtnCatalog.addEventListener('click', (e) => {

	if(menuWrapper.classList.contains("_active")){
		menuWrapper.classList.toggle('_active');
		catalogWrapper.classList.toggle('_active');
		return;
	}

	if ($html.classList.contains('_burger-open')) {
		$html.classList.remove('_burger-open');
		catalogWrapper.classList.remove('_active');
		menuWrapper.classList.remove('_active');
	} else {
		$html.classList.add('_burger-open');
		catalogWrapper.classList.add('_active');
	}

});

new Accordion(document.querySelector('.js--burger-menu-menu'), {
	elementClass: 'js--burger-menu-menu-element',
	triggerClass: 'js--burger-menu-menu-trigger',
	panelClass: 'js--burger-menu-menu-panel',
	activeClass: '_active',
	showMultiple: true,
	onlyChildNodes: true,
});


